var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "scan_and_category_config",
      attrs: { model: _vm.value.config, disabled: _vm.disabled },
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("设置分类及排序 "),
        _c("span", [_vm._v("（拖动分类可调整排序）")]),
      ]),
      _c("div", { staticClass: "tips" }, [
        _vm._v(" 建议宽度为332，高度不限，支持JPG、PNG等格式，大小不超过2M "),
      ]),
      _c(
        "draggable",
        {
          attrs: { animation: "500", "force-fallback": true },
          model: {
            value: _vm.value.config.value,
            callback: function ($$v) {
              _vm.$set(_vm.value.config, "value", $$v)
            },
            expression: "value.config.value",
          },
        },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "box" },
            [
              _c("div", { staticClass: "type" }, [
                _vm._v(" " + _vm._s(_vm.getType(item.type)) + " "),
              ]),
              _c(
                "el-form-item",
                {
                  ref: item.type,
                  refInFor: true,
                  attrs: {
                    prop: "value." + index + ".imageurl",
                    rules: [
                      {
                        required: true,
                        message: _vm.getType(item.type) + "不可为空",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "upload-item-wrap" },
                    [
                      _c("upload-file", {
                        ref: "uploadBanner",
                        refInFor: true,
                        attrs: {
                          "link-url": _vm.linkUrl,
                          tempurl: item.imageurl,
                          canDel: Boolean(item.imageurl),
                          deletePadding: true,
                          uploadInfo: _vm.uploadInfo,
                        },
                        on: {
                          onDelete: function ($event) {
                            return _vm.onDelete(item)
                          },
                          emitUploadFile: function (res) {
                            return _vm.emitUploadFile(res, item, "imageurl")
                          },
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "right" },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.onUpload(index)
                                },
                              },
                            },
                            [_vm._v("上传图片")]
                          ),
                          _vm.pictureList.length > 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectPicture(index)
                                    },
                                  },
                                },
                                [_vm._v("选择图片")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }